import { render, staticRenderFns } from "./store-order-list.vue?vue&type=template&id=0a0b912b&scoped=true"
import script from "./store-order-list.vue?vue&type=script&lang=js"
export * from "./store-order-list.vue?vue&type=script&lang=js"
import style0 from "./store-order-list.vue?vue&type=style&index=0&id=0a0b912b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b912b",
  null
  
)

export default component.exports